import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#f9fafb',
      padding: '20px'
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '16px',
        padding: '48px',
        maxWidth: '420px',
        width: '100%',
        textAlign: 'center',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
        border: '1px solid #e5e7eb'
      }}>
        <div style={{ marginBottom: '32px' }}>
          {/* Illustrated 404 icon */}
          <div style={{
            width: '120px',
            height: '120px',
            margin: '0 auto 24px',
            backgroundColor: '#f3f4f6',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="1.5">
              <circle cx="12" cy="12" r="10"/>
              <path d="M8 15s1.5-2 4-2 4 2 4 2"/>
              <line x1="9" y1="9" x2="9.01" y2="9" strokeWidth="2.5" strokeLinecap="round"/>
              <line x1="15" y1="9" x2="15.01" y2="9" strokeWidth="2.5" strokeLinecap="round"/>
            </svg>
          </div>

          <h1 style={{
            fontSize: '72px',
            fontWeight: '800',
            color: '#111827',
            margin: '0 0 8px 0',
            lineHeight: 1,
            letterSpacing: '-2px'
          }}>404</h1>

          <h2 style={{
            fontSize: '24px',
            fontWeight: '600',
            color: '#374151',
            margin: '0 0 12px 0'
          }}>Page Not Found</h2>

          <p style={{
            color: '#6b7280',
            fontSize: '15px',
            margin: 0,
            lineHeight: 1.6
          }}>
            Oops! The page you're looking for doesn't exist or has been moved to another location.
          </p>
        </div>

        <div style={{ display: 'flex', flexDirection: 'row', gap: '12px' }}>
          <button
            onClick={() => navigate(-1)}
            style={{
              flex: 1,
              padding: '14px 24px',
              backgroundColor: '#2563eb',
              color: 'white',
              border: 'none',
              borderRadius: '10px',
              fontSize: '15px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)'
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = '#1d4ed8';
              e.target.style.transform = 'translateY(-1px)';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = '#2563eb';
              e.target.style.transform = 'translateY(0)';
            }}
          >
            Go Back
          </button>
          <button
            onClick={() => navigate('/overview')}
            style={{
              flex: 1,
              padding: '14px 24px',
              backgroundColor: 'white',
              color: '#374151',
              border: '1px solid #d1d5db',
              borderRadius: '10px',
              fontSize: '15px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.2s ease'
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = '#f9fafb';
              e.target.style.borderColor = '#9ca3af';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = 'white';
              e.target.style.borderColor = '#d1d5db';
            }}
          >
            Go to Overview
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
